export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/shipping-companies`,
        name: `${prefix}.shipping-companies.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.shipping-companies.index`,
                PageDescription: "Supplier Configurations: Shipping companies",
            },
        },
    },
];
